<template>
    <section class="booking shouldFix" v-bind:class="{ open: open }">
      <!-- <div class="block"></div> -->
      <div class="main">
        <!-- <div class="bookmark"><img src="../../asset/svg/bookmark/v/contact.svg" alt="聯絡多寶"></div> -->
        <div class="max1000"><a href="javascript:void(0)" class="arrow_back" v-on:click="close()">
            <svg class="arrowtop" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.86 18.28"><title>top</title><path d="M33.38,15.63,16,.39a1.57,1.57,0,0,0-2.58,1.15Q7.08,8.78.42,15.73c-1.33,1.38.77,3.49,2.1,2.1Q9.12,11,15.37,3.8l15.9,13.94C32.71,19,34.82,16.9,33.38,15.63Z" /></svg>
            <svg class="arrowbg"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.86 93.28"><title>btn</title><path d="M0,48.67C-.06,29,12.8,9.5,31,1.79c12.47-5.27,33.3,1.68,39.81,13.45C73.66,20.35,78,24,82.3,27.59c3,2.52,4.79,5.39,4.3,9.48-.39,3.29,1,6.16,2.46,9a15.11,15.11,0,0,1,.18,14c-12.18,25.24-30,34.78-54.36,33a16,16,0,0,1-8.06-2.36C11.93,80.51,0,68.37,0,48.67Z" /></svg></a>
          <h2 class="artistdescription"><img src="../../asset/svg/booking.svg" alt="預約參訪"></h2>
            <form>
                <p class="w50l">
                  <input type="txet" name="name" v-model="username" required>
                  <label for="name">姓名*</label><span class="bar"></span>
                </p>
                <p class="w50r">
                  <input type="tel" name="phone" v-model="phone" required>
                  <label for="phone">聯絡電話*</label><span class="bar"></span>
                </p>
                <p class="w50l w100">
                  <input type="text" name="email" v-model="email" required>
                  <label for="email">E-mail*</label><span class="bar"></span>
                </p>
                <p class="w50r w100">
                  <input type="text" name="group" v-model="group" required>
                  <label for="group">參訪團體名稱</label><span class="bar"></span>
                </p>
                <p class="w50l w100">
                  <input type="number" name="people" v-model="people" required min="1" style="text-indent:50%;">
                  <label for="people">預計參訪人數*</label><span class="bar"></span>
                </p>
                <p class="w50r w100">
                  <input type="date" name="date" v-model="date" required style="text-indent:20%;">
                  <label for="date">預計參訪日期*</label><span class="bar"></span>
                </p>
                <p class="knowabout">
                  <textarea type="textarea" name="textarea" v-model="comment" required></textarea>
                  <label for="textarea">關於多寶想了解什麼</label><span class="bar"></span>
                </p>
              </form>

            <a href="#" v-on:click="set_form()"  class="btn" >


            <!--checkicon --> 
            <div class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.47 29.3"><title>check</title><path d="M31.39.45c-5.57,5.83-10.84,12-16.12,18.07-2.58-2.9-4.23-6.4-7.19-9.06-1.42-1.28-3.53.82-2.1,2.1,3.44,3.1,5.11,7.36,8.57,10.47a1.56,1.56,0,0,0,2.58-1.11c5.37-6.2,10.71-12.44,16.38-18.36C34.82,1.17,32.71-.93,31.39.45Z" /><path d="M20.28,4.13a1.91,1.91,0,0,0,2.35-1.47.62.62,0,0,0,0-.34,1.65,1.65,0,0,0-1.23-.88A16,16,0,0,0,18.58,1,103.45,103.45,0,0,0,3.44.85C.86,1,.06,1.51,0,4.29,0,11.18,0,18.09,0,23.35a20.44,20.44,0,0,0,.27,2.78c.05.36.1.71.15,1.07a1.76,1.76,0,0,0,1.75,1.67c.44,0,.88.07,1.33.12.59.06,1.18.12,1.78.14q5.85.18,11.67.18c5.3,0,10.56-.11,15.74-.33a33.42,33.42,0,0,0,3.85-.4c1.56-.25,1.89-.76,2.09-2.18a93.72,93.72,0,0,0,.74-15.81A12,12,0,0,0,39,7.9a1.62,1.62,0,0,0-1.64-1,1.25,1.25,0,0,0-.92.63,1.49,1.49,0,0,0,0,1.32,1.52,1.52,0,0,1,.14.58v2.31c0,2.59,0,5.26-.07,7.88,0,1.2-.16,2.43-.28,3.62-.08.84-.17,1.68-.23,2.52,0,.08,0,.13,0,.14l-.2,0-1.61.13c-1,.09-2,.18-3.06.19-6.84.07-14.23.12-23.24.16-1,0-2.07,0-3.08-.09l-1.69-.07H3a7.6,7.6,0,0,0-.07-1c0-.23-.06-.47-.06-.7l-.07-3.27c-.09-4.16-.19-8.45-.23-12.68,0-1.23.07-2.46.15-3.76,0-.4.05-.8.08-1.2,9.63-.55,3.89-.49,16.13.18Z" /></svg></div><span>確認送出</span></a>
        </div>
      </div>

    </section>
</template>
<script>
 // Vue.component({
 //      props: ['open']
 //  })

  export default {
    data: function() {
        return {
            username: '',
            phone: '',
            email: '',
            group: '',
            people: '',
            date: '',
            comment: ''
        }
    },
    props: ['open'],
    mounted:function(){
      if(this.getMobileOperatingSystem()) {
        screen.orientation.onchange = function (){
            var way = screen.orientation.type.match(/\w+/)[0];
            if (way == "landscape"){
                $('.trans_bg').removeClass('input_focus');
            }
        };
      }

      $('input, textarea').on('focus',function(){
          $('.trans_bg').addClass('input_focus');
      })
    },
    methods: {
        getMobileOperatingSystem:function() {
          var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/android/i.test(userAgent)) {
                return true;
            }
            return false;
        },
        set_form:function() {
           var username = this.username,
               phone = this.fullToHalf(this.phone),
               email = this.email,
               group = this.group,
               people = this.fullToHalf(this.people),
               date = this.date,
               comment = this.comment;

          if (username.length < 2 || phone.length < 6 || email.length < 5 || people.length == 0 || date.length == 0) {
            // console.log(username.length , phone.length, email.length , group.length , people.length ,date.length,comment.length )
            var all_val = new Array(username,phone,email,people,date);
            var des;
            $.each( all_val, function( key, value ) {
              console.log(key);
              if(key == 0 && value.length < 2){
                des = "<font>姓名</font>";
                $('.inputName').append(des);
              }
              if(key == 1 && value.length < 6){
                des = "<font>電話</font>";
                $('.inputName').append(des);
              }
              if(key == 2 && email.length < 5){
                des = "<font>E-mail</font>";
                $('.inputName').append(des);
              }
              if( value.length == 0 && key > 2){
                switch (key){
                  case 3:
                    des = "<font>人數</font>";
                    break;
                  case 4:
                    des = "<font>日期</font>";
                    break;
                }
                $('.inputName').append(des);
              }
            });
            $('.reminder').addClass('show').find('.wrong').fadeIn();

          } else {
              var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
              if (!regex.test(email)) {
                $('.inputName').html('E-mail格式');
                $('.reminder').addClass('show').find('.wrong').fadeIn();;
                  // $('.reminder').show();
              } else {
                console.log(username,phone,email,group,people,date,comment);
                $.ajax({
                  type: 'POST',
                  url: 'edm/edm.php',
                  data: {
                     username: username,
                     phone: phone,
                     email: email,
                     group: group,
                     people: people,
                     date: date,
                     comment: comment
                  },
                  success: function(data, textStatus, jqXHR)
                  {
                      console.log(data,textStatus);
                      $('.reminder').addClass('show').find('.right').fadeIn();
                      gaclick('btn_email');
                  },
                  error: function (jqXHR, textStatus, errorThrown)
                  {
                      console.log(textStatus,errorThrown)
                  }
                });
              }
          }
        },
        fullToHalf:function(val) {
          var value = val || "";
          var result = "";
          if (value) {
            for (var i = 0; i <= value.length; i++) {
              if (value.charCodeAt(i) == 12288) {
                result += " ";
              } else {
                if (value.charCodeAt(i) > 65280 && value.charCodeAt(i) < 65375) {
                  result += String.fromCharCode(value.charCodeAt(i) - 65248);
                } else {
                  result += String.fromCharCode(value.charCodeAt(i));
                }
              }
            }
          } 
          return result;
        },
        close:function(){
          this.$emit('close');
        }
    }
  }
</script>



// WEBPACK FOOTER //
// Booking.vue?1b052ce5